exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-b278bdea] {\n  max-width: 600px !important;\n}\n", ""]);

// exports
